module.exports = __webpack_public_path__ + "media/static/icons/icon-chevron-circle-left--white-a0fd00dcdebc0be80461f5f4f1ad8185.svg";